var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTrash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5C11.6022 4.5 11.2206 4.65804 10.9393 4.93934C10.658 5.22064 10.5 5.60218 10.5 6V7.5H17.5V6C17.5 5.60218 17.342 5.22064 17.0607 4.93934C16.7794 4.65804 16.3978 4.5 16 4.5H12ZM18.5 7.5V6C18.5 5.33696 18.2366 4.70107 17.7678 4.23223C17.2989 3.76339 16.663 3.5 16 3.5H12C11.337 3.5 10.7011 3.76339 10.2322 4.23223C9.76339 4.70107 9.5 5.33696 9.5 6V7.5H5C4.72386 7.5 4.5 7.72386 4.5 8C4.5 8.27614 4.72386 8.5 5 8.5H6.5V22C6.5 22.663 6.76339 23.2989 7.23223 23.7678C7.70107 24.2366 8.33696 24.5 9 24.5H19C19.663 24.5 20.2989 24.2366 20.7678 23.7678C21.2366 23.2989 21.5 22.663 21.5 22V8.5H23C23.2761 8.5 23.5 8.27614 23.5 8C23.5 7.72386 23.2761 7.5 23 7.5H18.5ZM7.5 8.5V22C7.5 22.3978 7.65804 22.7794 7.93934 23.0607C8.22064 23.342 8.60218 23.5 9 23.5H19C19.3978 23.5 19.7794 23.342 20.0607 23.0607C20.342 22.7794 20.5 22.3978 20.5 22V8.5H7.5ZM12 12.5C12.2761 12.5 12.5 12.7239 12.5 13V19C12.5 19.2761 12.2761 19.5 12 19.5C11.7239 19.5 11.5 19.2761 11.5 19V13C11.5 12.7239 11.7239 12.5 12 12.5ZM16 12.5C16.2761 12.5 16.5 12.7239 16.5 13V19C16.5 19.2761 16.2761 19.5 16 19.5C15.7239 19.5 15.5 19.2761 15.5 19V13C15.5 12.7239 15.7239 12.5 16 12.5Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash.456fbb39.svg";
export { ForwardRef as ReactComponent };